export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_01.a48cd642.mp4";